import ShopifySurfacePickUp from '@pixelunion/shopify-surface-pick-up';
import $ from 'jquery';
import $script from 'scriptjs';
import ShopifyVariants from 'shopify-variants';
import ProductGallery from '../components/ProductGallery';
import SidebarDrawer from '../components/SidebarDrawer';

export default class StaticProduct {
  constructor({
    el,
    data,
    type,
    id,
  }) {
    this.$el = $(el);
    this.el = el;

    this.sectionType = type;
    this.data = data;
    this.sectionId = id;
    this.product = data.product;
    this.cartText = data.cartText;
    this.enableSendToCart = data.settings.enable_send_to_cart;

    this.unitPrice = this.el.querySelector('[data-unit-price]');
    this.totalQuantity = this.el.querySelector('[data-total-quantity]');
    this.unitPriceAmount = this.el.querySelector('[data-unit-price-amount]');
    this.unitPriceMeasure = this.el.querySelector('[data-unit-price-measure]');
    this.addToCartButton = this.el.querySelector('input.add-to-cart');

    this.$options = this.$el.find('[data-product-option]');
    this.$variants = this.$el.find('[data-variants]');
    this.$form = this.$el.find('[data-product-form]');

    this.timeouts = [];

    $script($('[data-scripts]').data('shopify-api-url'), () => {
      this.isThemeEditor = window.Shopify && window.Shopify.designMode;

      this.productGallery = new ProductGallery(
        this.el.querySelector('[data-product-gallery]'),
        {
          enable_video_autoplay: this.data.settings.gallery_enable_video_autoplay,
          enable_video_looping: this.data.settings.gallery_enable_video_looping,
          enable_zoom: this.data.settings.gallery_enable_zoom,
        },
      );

      this._bindEvents();

      Shopify.onError = XMLHttpRequest => this._handleErrors(XMLHttpRequest);

      if (!this.product) return;

      if (this.$options.length) {
        this.variantHelper = new ShopifyVariants(this.product, this.$variants, this.$options);
      }

      const selectedVariant = () => (this.variantHelper
        ? this.variantHelper.getSelectedVariant()
        : this.product.variants[0]); // product has only default variant

      const surfacePickUpEl = this.el.querySelector('.surface-pick-up');

      if (surfacePickUpEl) {
        this.surfacePickUp = new ShopifySurfacePickUp(this.el.querySelector('[data-surface-pick-up]'));
        this.surfacePickUp.load(selectedVariant().id);
        this.surfacePickUp.onModalRequest(content => {
          const variantTitle = this.variantHelper
            ? `<div class="sidebar-drawer__surface-pick-up-variant">${selectedVariant().title}</div>`
            : '';

          const header = `
            <h2 class="sidebar-drawer__surface-pick-up-title">${this.product.title}</h2>
            ${variantTitle}
          `;

          SidebarDrawer.open({ header, content });
        });
      }
    });
  }

  _bindEvents() {
    this.events = [
      this.$form.on(`submit.${this.sectionId}`, e => {
        if (!e.originalEvent.submitter || e.originalEvent.submitter !== this.addToCartButton) {
          // The zoom-in, zoom-out, and fullscreen buttons default to type="submit"
          // which results in the ATC being submitted when they are clicked.
          // Listen for the submit event and cancel unless the ATC button
          // was clicked.
          e.preventDefault();
        } else {
          this._addToCart(e);
        }
      }),
      $(window).on(`shopify-variants:switch-variant.${this.sectionId}`, (event, data) => {
        this._changeVariant(data);
      }),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off(`.${this.sectionId}`));
  }

  _updateUnitPrice(variant) {
    if (this.unitPrice && 'unit_price_measurement' in variant) {
      this.totalQuantity.innerHTML = `${variant.unit_price_measurement.quantity_value}${variant.unit_price_measurement.quantity_unit}`;

      this.unitPriceAmount.innerHTML = Shopify.formatMoney(variant.unit_price, Shop.moneyFormat);
      if (variant.unit_price_measurement.reference_value === 1) {
        this.unitPriceMeasure.innerHTML = variant.unit_price_measurement.reference_unit;
      } else {
        this.unitPriceMeasure.innerHTML = `${variant.unit_price_measurement.reference_value}${variant.unit_price_measurement.reference_unit}`;
      }
      if (variant.price > 0) {
        this.unitPrice.classList.remove('product-details__unit-price--hidden');
      } else {
        this.unitPrice.classList.add('product-details__unit-price--hidden');
      }
    } else if (this.unitPrice) {
      this.unitPrice.classList.add('product-details__unit-price--hidden');
    }
  }

  _changeVariant({ product, variant, firstLoad }) {
    if (firstLoad || this.product !== product) {
      return;
    }

    if (this.surfacePickUp) {
      this.surfacePickUp.load(variant.id);
    }

    // Update URL
    if (this.data.enableHistory) {
      this._changeUrl(variant);
    }

    // Load image
    this.productGallery.selectMediaByVariant(variant);

    // Compare at price
    this.$el.find('[data-variant-compare-at-price]')
      .toggleClass(
        'hidden',
        (
          !variant.compare_at_price
          || variant.price === variant.compare_at_price
        ),
      )
      .text(Shopify.formatMoney(variant.compare_at_price, Shop.moneyFormat));

    // Price
    this.$el.find('[data-variant-price]')
      .text(Shopify.formatMoney(variant.price, Shop.moneyFormat));

    this._updateUnitPrice(variant);
  }

  _changeUrl(variant) {
    if (this.isThemeEditor) {
      return;
    }

    const params = $.param({ variant: variant.id });
    const url = `${this.product.handle}?${params}`;
    history.replaceState({}, 'variant', url);
  }

  _addToCart(e) {
    e.preventDefault();

    $.ajax({
      type: 'POST',
      url: `${window.Theme.routes.cart_url}/add.js`,
      data: this.$form.serialize(),
      dataType: 'json',
    })
    // On success
      .done(variant => {
        if (this.enableSendToCart) {
          window.location.href = window.Theme.routes.cart_url;
          return;
        }

        $('.cart-count').addClass('active-cart');

        const message = this.data.message
          .replace('{{ product }}', variant.title)
          .replace('{{ cart_link }}', `<a href="${window.Theme.routes.cart_url}">${this.data.cartLink}</a>`)
          .replace('{{ continue_link }}', `<a href="${window.Theme.routes.all_products_collection_url}">${this.data.continueLink}</a>`)
          .replace('{{ checkout_link }}', `<button class="product-message__checkout-button" type="submit" name="checkout" form="checkout_form">${this.data.checkoutLink}</button>`);

        this.timeouts.push(setTimeout(() => {
          this.$el.find('.product-message')
            .html(message)
            .addClass('success-message')
            .removeClass('error-message');
          this._updateCart();
        },
        500));
      })
    // On failure
      .fail(response => this._handleErrors(response));
  }

  _updateCart() {
    return Shopify.getCart(cart => {
      $('.cart-item-count').text(cart.item_count);
      $('.header-tools-cart').addClass('cart-has-content');
    });
  }

  _handleErrors(response) {
    const error = JSON.parse(response.responseText);

    setTimeout(() => {
      this.$el.find('.product-message')
        .html(error.description)
        .addClass('error-message')
        .removeClass('success-message');
    }, 500);
  }

  onSectionUnload() {
    this._unbindEvents();
    if (this.variantHelper) {
      this.variantHelper.unload();
    }
    this.productGallery.unload();
    this.timeouts.forEach(timeout => clearTimeout(timeout));
  }
}
